import { Context } from '@leverege/plugin';
import { Dialogs } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { AllowedReducer } from '@leverege/api-redux';
import { GlobalState } from '@leverege/ui-redux';
import RevokeTemporaryUsersDialog from "../components/RevokeTemporaryUsersDialog.js";
const {
  t,
  tf
} = I18N.ns('temporaryUserManagement.action.Revoke');
export default {
  id: 'temporaryUserManagement.action.Revoke',
  type: 'ResourceTemporaryUsers.revoke',
  name: tf('name'),
  layout: {
    sort: 'revoke'
  },
  matches: {
    use: 'contextMenu',
    client: 'ResourceTemporaryUsers'
  },
  appearance: opts => {
    const {
      context
    } = opts;
    const users = Context.getTargetsOfType(context, 'temporaryUser');
    const disabled = users == null || users.length === 0;
    const name = t('appearanceName', {
      count: users.length
    });
    return {
      name,
      disabled,
      visible: true
    };
  },
  prepare: async context => {
    const {
      clientProps: {
        actions,
        dispatch
      }
    } = context;
    const users = Context.getTargetsOfType(context, 'temporaryUser');
    const allowed = users?.map(u => AllowedReducer.get(GlobalState.get(), typeof u === 'string' ? u : u.username));
    const promises = [];
    for (let i = 0; i < allowed?.length; i++) {
      if (typeof allowed[i].revokeTemporaryUser !== 'boolean') {
        promises.push(dispatch(actions.temporaryUser(users[i]).canRevoke()));
      }
    }
    return Promise.all(promises);
  },
  isPrepared: context => {
    const users = Context.getTargetsOfType(context, 'temporaryUser');
    const allowed = users?.map(u => AllowedReducer.get(GlobalState.get(), typeof u === 'string' ? u : u.username));
    return users?.length > 0 ? allowed?.every(a => typeof a.revokeTemporaryUser === 'boolean') : true;
  },
  handles: context => {
    const users = Context.getTargetsOfType(context, 'temporaryUser');
    if (!users || users.length === 0) {
      return false;
    }
    const allowed = users.map(u => AllowedReducer.get(GlobalState.get(), typeof u === 'string' ? u : u.username));
    for (let i = 0; i < users.length; i++) {
      const obj = typeof users[i] === 'string' ? context.clientProps?.users?.find(u => u.username === users[i]) : users[i];
      if (obj.revokedAt != null) {
        return false;
      }
    }
    return allowed.every(a => a.revokeTemporaryUser === true) || false;
  },
  perform: ({
    context
  }) => {
    const users = Context.getTargetsOfType(context, 'temporaryUser');
    const {
      actions,
      api,
      emailOptions,
      smsOptions,
      uiName,
      uiUrl
    } = context;
    Dialogs.show({
      component: RevokeTemporaryUsersDialog,
      props: {
        userIds: users?.map(u => typeof u === 'string' ? u : u.username) || [],
        actions,
        api,
        emailOptions,
        smsOptions,
        uiName,
        uiUrl
      }
    });
  }
};